import { render } from "./Pause.vue?vue&type=template&id=4b3edf3f&scoped=true"
import script from "./Pause.vue?vue&type=script&lang=js"
export * from "./Pause.vue?vue&type=script&lang=js"

import "./Pause.vue?vue&type=style&index=0&id=4b3edf3f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b3edf3f"

export default script